import {useSelector} from 'react-redux';
import {currentResource} from '../../../util/utils';

export default () =>
	useSelector(({errors, isModalOpen}) => {
		const hasErrors = errors?.length > 0;

		let formattedErrors = [];

		if (hasErrors) {
			formattedErrors = errors.map((error) => {
				const {level = 'error', Message: message = '', ErrorCode: code = ''} = error;

				const resourceMessage = currentResource.Errors[code] ?? message;

				return {level, message: resourceMessage, code};
			});
		}

		return [formattedErrors, isModalOpen];
	});
